<template>
  <div class="b2c-order">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col
              class="d-flex justify-content-between align-items-center"
              cols="12"
          >
            <input
                ref="importNumberInput"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                class="hidden"
                type="file"
                @change="importNumber"
            />
            <h4>
              Danh sách đơn hàng
              <a
                  v-b-tooltip.hover.top="'Lấy lại danh sách!'"
                  class="btn-icon"
                  @click="$router.go()"
              >
                <feather-icon icon="RepeatIcon"/>
              </a>
              <span
                  v-if="isFirstTimeLoad"
                  class="text-primary text-center font-weight-bold font-medium-2"
              >
                Vui lòng nhập điều kiện tìm kiếm để hiển thị đơn hàng
              </span>
            </h4>
            <span class="float-right d-flex" style="gap: 10px">
              <b-button
                  class="text-nowrap"
                  size="sm"
                  variant="primary"
                  @click="handleOpenModalChangeOrderStatus"
              >
                Cập nhật trạng thái đơn
              </b-button>
              <b-button
                  class="text-nowrap"
                  size="sm"
                  variant="primary"
                  @click="$refs.importNumberInput.click()"
              >
                Nhập số liên hệ
              </b-button>
<!--              <b-button-->
<!--                  class="text-nowrap"-->
<!--                  size="sm"-->
<!--                  variant="primary"-->
<!--                  @click="$bvModal.show('popupCreateSimOrder')"-->
<!--              >-->
<!--                Tạo đơn Sim-->
<!--              </b-button>-->
<!--              <b-button-->
<!--                  class="text-nowrap"-->
<!--                  size="sm"-->
<!--                  variant="primary"-->
<!--                  @click="$bvModal.show('popupCreateOrder')"-->
<!--              >-->
<!--                Tạo đơn Thiết bị-->
<!--              </b-button>-->
              <b-input-group>
                <b-form-input
                    v-model="searchString"
                    class="style-input"
                    placeholder="Tìm kiếm nhanh"
                    size="sm"
                    @keypress.enter="quickSearch"
                />
                <b-input-group-append
                    is-text
                    role="button"
                    @click="quickSearch"
                >
                  <feather-icon icon="SearchIcon"/>
                </b-input-group-append>
              </b-input-group>
            </span>
          </b-col>
          <b-col cols="12">
            <b-tabs>
              <b-tab active title="Tất cả đơn hàng" @click="changeTab(null)">
              </b-tab>
              <b-tab title="Đơn chờ thanh toán" @click="changeTab(0)"></b-tab>
              <b-tab title="Chờ xác nhận/COD" @click="changeTab(1)"></b-tab>
              <b-tab title="Đã xác nhận" @click="changeTab(2)"></b-tab>
              <b-tab title="Hoàn tất" @click="changeTab(3)"></b-tab>
              <b-tab title="Đơn hàng lỗi" @click="changeTab(90)"></b-tab>
              <b-tab title="Trả hàng" @click="changeTab(91)"></b-tab>
            </b-tabs>
          </b-col>
          <!-- Per Page -->
        </b-row>

        <b-row>
          <b-col cols="12">
            <vue-good-table
                :columns="fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :pagination-options="{
                perPage: serverParams.pageSize,
                enabled: true,
                perPageDropdown: [20, 50, 100],
                dropdownAllowAll: false
              }"
                :rows="rows"
                :totalRows="totalRecords"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <b-dropdown
                      no-caret
                      size="sm"
                      toggle-class="text-decoration-none"
                      variant="link"
                  >
                    <template v-slot:button-content>
                      <feather-icon
                          class="text-body align-middle mr-25"
                          icon="MoreVerticalIcon"
                          size="16"
                      />
                    </template>
                    <b-dropdown-item @click="view(props.index)">
                      <feather-icon class="mr-50" icon="EyeIcon"/><span
                    >Xem chi tiết</span
                    >
                    </b-dropdown-item>
                    <b-dropdown-item @click="viewChangetstaus(props.index)">
                      <feather-icon class="mr-50" icon="Edit3Icon"/><span
                    >Chuyển trạng thái</span
                    >
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <feather-icon class="mr-50" icon="RadioIcon"/><span
                    >Thông tin kích hoạt</span
                    >
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
                <span v-else-if="props.column.field === 'DeliveryType'">
                  <feather-icon
                      v-if="props.row.DeliveryType == 1"
                      icon="CheckIcon"
                  />
                </span>
                <span v-else-if="props.column.field === 'IsFast'">
                  <feather-icon v-if="props.row.IsFast == 1" icon="CheckIcon"/>
                </span>
                <span v-else-if="props.column.field === 'TotalPrice'">
                  {{ props.formattedRow[props.column.field] | number }}
                </span>
                <span
                    v-else-if="
                    props.column.field === 'Phones' && props.row.Phones
                  "
                >
                  <span v-html="props.row.Phones.replace(/,/g, '<br>')"/>
                </span>
                <span v-else-if="props.column.field === 'Id'">
                  <a class="text-primary" @click="view(props.index)">{{
                      props.row.Id
                    }}</a>
                </span>
                <span v-else-if="props.column.field === 'PaymentChannel'">
                  <a class="text">{{
                      props.row.PaymentChannel == "BANKTRANFER"
                          ? "Chuyển khoản"
                          : props.row.PaymentChannel
                    }}</a>
                </span>
                <span v-else-if="props.column.field === 'ECommercePlatform'">
                  <a class="text">{{ props.row.ECommercePlatform }}</a>
                </span>
                <span v-else-if="props.column.field === 'ECommerceNotes'">
                  <a class="text">{{ props.row.ECommerceNotes }}</a>
                </span>
                <span v-else-if="props.column.field === 'GHTK_Id'">
                  <a
                      v-if="
                      props.row && props.row.IsFast == 1 && props.row.J_Shipment
                    "
                      :href="props.row.J_Shipment.shared_link"
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                  <a
                      v-else-if="props.row.ShippingPartner === 'GHN'"
                      :href="
                      'https://donhang.ghn.vn/?order_code=' + props.row.GHTK_Id
                    "
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                  <a
                      v-else-if="props.row.ShippingPartner === 'TIKI'"
                      :href="
                      'https://tnsl-tracking.tiki.com.vn/?id=' +
                        props.row.GHTK_Id
                    "
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                  <a
                      v-else-if="props.row.ShippingPartner === 'VTP'"
                      :href="'https://viettelpost.com.vn/tra-cuu-hanh-trinh-don'"
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                  <a
                      v-else
                      :href="'https://i.ghtk.vn/' + props.row.GHTK_Id"
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                </span>
                <span v-else-if="props.column.field === 'Status'">
                  <span class="badge badge-light-info">{{
                      listOrderStatus.find(m => m.id == props.row.Status)?listOrderStatus.find(m => m.id == props.row.Status).text:""
                    }}</span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
        id="modal-change-status"
        :title="'Thay đổi trạng thái đơn ' + currentItem.Id"
        @ok="handleChangeStatus"
    >
      <validation-observer ref="modalView">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Trạng thái mới">
              <Select2
                  v-model="currentItem.newStatus"
                  :options="listOrderStatus.filter(i => i.id != 90)"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Ghi chú">
              <b-form-textarea v-model="currentItem.notes"/>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-view"
        :title="'Thông tin đơn hàng ' + currentItem.Id"
        ok-only
        size="xl"
        @hide="handleHide"
        @ok="handleOk"
    >
      <validation-observer ref="modalView">
        <b-row class="border-bottom pb-1 mb-1">
          <b-col
              v-for="i in listOrderStatus"
              :key="i.id"
              :class="i.has ? 'text-primary' : ''"
              cols="2"
          >
            <feather-icon
                v-if="currentItem.Status >= i.id"
                icon="CheckSquareIcon"
            />
            {{ i.text }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <h4>Thông tin khách hàng</h4>
            <b-card body-class="p-1">
              <b-card-text>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Tên khách hàng">
                      <b-form-input
                          v-model="currentItem.FullName"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="5">
                    <b-form-group label="Số liên hệ">
                      <b-form-input
                          v-model="currentItem.ContactPhone"
                          :disabled="!isEditPhoneEmail"
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col class="pl-0" cols="7">
                    <b-form-group label="Email">
                      <b-form-input
                          v-model="currentItem.Email"
                          :disabled="!isEditPhoneEmail"
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <!---Only show for e-commerce order-->
                  <b-col cols="12">
                    <b-form-group label="Địa chỉ">
                      <b-form-input
                          v-if="
                          currentItem.Addr && currentItem.CreateFrom === 'TMĐT'
                        "
                          v-model="currentItem.Addr"
                          :disabled="
                          !(isEditPhoneEmail && currentItem.Status == 1)
                        "
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" :class="[{'mb-3': !currentItem.DeliveryType==1 || !currentItem.City},'text-right']"><b-button variant="primary" @click="updatePhoneAndMail" size="sm">{{ isEditPhoneEmail ? 'Lưu' : 'Sửa' }}</b-button></b-col> -->
                  <b-col
                      v-if="currentItem.DeliveryType == 1 && currentItem.CityId"
                      cols="12"
                  >
                    <b-row>
                      <b-col cols="12">
                        <b-form-group label="Tỉnh/Thành phố">
                          <search-select
                              v-model="currentItem.CityId"
                              :disabled="
                              !(isEditPhoneEmail && currentItem.Status == 1)
                            "
                              :options="Cities"
                              @change="fetchDistricts(true)"
                          ></search-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Quận/Huyện">
                          <search-select
                              v-model="currentItem.DistrictId"
                              :disabled="
                              !(isEditPhoneEmail && currentItem.Status == 1)
                            "
                              :options="Districts"
                              @change="fetchWards(true)"
                          ></search-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Phường/Xã/Thị trấn">
                          <search-select
                              v-model="currentItem.WardId"
                              :disabled="
                              !(isEditPhoneEmail && currentItem.Status == 1)
                            "
                              :options="Wards"
                          ></search-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="ẤP/Khu/Tòa">
                          <search-select
                              v-model="currentItem.HamletId"
                              :disabled="
                              !(isEditPhoneEmail && currentItem.Status == 1)
                            "
                              :options="hamlets"
                          ></search-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Địa chỉ">
                          <b-form-input
                              v-model="currentItem.Addr"
                              :disabled="!isEditPhoneEmail"
                              size="sm"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Đối tác giao hàng">
                          <search-select
                              v-model="currentItem.ShippingPartner"
                              :disabled="!this.currentItem.changeShippingPartner"
                              :options="this.Partner"
                          ></search-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <!--                  <b-col cols="9">-->
                  <!--                    <b-form-group label="">-->
                  <!--                      <b-form-checkbox-->
                  <!--                        v-model="currentItem.IsFast"-->
                  <!--                        value="1"-->
                  <!--                        disabled-->
                  <!--                      >-->
                  <!--                        Giao hàng hoả tốc-->
                  <!--                      </b-form-checkbox>-->
                  <!--                    </b-form-group>-->
                  <!--                  </b-col>-->
                  <!--                  <b-col-->
                  <!--                    cols="3"-->
                  <!--                    class="text-right"-->
                  <!--                    v-if="currentItem.IsFast == 1"-->
                  <!--                    ><span-->
                  <!--                      @click="ahmOrderCancel"-->
                  <!--                      role="button"-->
                  <!--                      class="text-primary"-->
                  <!--                      v-if="currentItem.GHTK_Id"-->
                  <!--                      >Huỷ đơn</span-->
                  <!--                    ></b-col-->
                  <!--                  >-->
                  <b-col
                      v-if="currentItem.DeliveryType == 1"
                      class="text-right d-flex justify-content-end col-gap-1"
                      cols="12"
                  >
                    <b-button
                        size="sm"
                        variant="primary"
                        @click="updatePhoneAndMail"
                    >{{ isEditPhoneEmail ? "Lưu" : "Sửa" }}
                    </b-button>
                    <b-button
                        size="sm"
                        variant="primary"
                        @click="createShipmentGHN"
                    >Tạo vận đơn
                    </b-button>
                    <b-button
                        v-if="!currentItem.IsFast"
                        size="sm"
                        variant="secondary"
                        @click="createShipment1"
                    >Tạo đơn mới GHTK
                    </b-button>
                    <b-button
                        v-if="currentItem.IsFast == 1 && currentItem.GHTK_Id"
                        size="sm"
                        variant="primary"
                        @click="ahmOrderCancel"
                    >Hủy đơn
                    </b-button>
                  </b-col>
                </b-row>
                <b-row class="mt-1">
                  <b-col cols="12">
                    <b-form-group label="Ghi chú">
                      <b-form-input v-model="currentItem.note" size="sm"/>
                    </b-form-group>
                  </b-col>
                  <b-col
                      class="text-right d-flex justify-content-end col-gap-1"
                      cols="12"
                  >
                    <b-button
                        size="sm"
                        variant="primary"
                        @click="printEcomLabel"
                    >In tem sàn
                    </b-button>
                    <b-button size="sm" variant="primary" @click="addNote"
                    >Lưu
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
            <h4>Các số iTel trong đơn</h4>
            <b-card
                v-if="currentItem.ListPhones && !isLoading"
                body-class="p-0"
            >
              <b-card-text>
                <table class="table table-striped">
                  <tr v-for="p in currentItem.ListPhones" :key="p.Msisdn">
                    <td class="p-1">
                      <b-row class="border-bottom">
                        <b-col class="text-primary h4  pb-1" cols="8">
                          {{ p.Msisdn }}
                          <figure v-if="p.MSIN_" class="mb-0 mt-1 border py-1">
                            <img
                                :src="$ctx.API_URL + 'util/barcode/' + p.MSIN_"
                                alt="barcode"
                                style="width:100%"
                            />
                            <figcaption style="text-align: center">
                              <small class="text-secondary"
                              ><b>{{ p.MSIN_ }}</b></small
                              >
                            </figcaption>
                          </figure>
                        </b-col>
                        <b-col class="d-flex align-items-center" cols="4">
                          <img
                              v-if="p.QRCODE"
                              :src="$ctx.API_URL + 'util/qr/' + p.QRCODE"
                              alt="qrcode"
                              style="width: 80px; height: 80px"
                          />
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="6">Loại SIM:</b-col>
                        <b-col cols="6">
                          <span>
                            <feather-icon
                                :icon="
                                p.ESIM == 1 ? 'CheckSquareIcon' : 'SquareIcon'
                              "
                            />
                            eSIM?
                          </span>
                        </b-col>
                        <b-col class="bg-light" cols="6">Giá số:</b-col>
                        <b-col class="bg-light" cols="6"
                        >{{ p.Price | number }}
                        </b-col>
                        <b-col cols="6">Giá SIM/eSIM:</b-col>
                        <b-col v-if="p.ESIM == 1" cols="6"
                        >{{ p.EsimPrice | number }}
                        </b-col>
                        <b-col v-else cols="6">{{ p.SimPrice | number }}</b-col>
                        <b-col class="bg-light" cols="6"
                        >Gói: {{ p.Package }}
                        </b-col>
                        <b-col class="bg-light" cols="6"
                        >{{ p.PackPrice | number }}/tháng
                        </b-col>
                        <b-col cols="6">Cam kết:</b-col>
                        <b-col cols="6">
                          <span v-if="!p.CommitType">Không</span>
                          <span v-else-if="p.CommitType === 'PSC'"
                          >Tiêu dùng TKC</span
                          >
                          <span v-else-if="p.CommitType === 'PACK'"
                          >Gói cước {{ p.Months }} tháng</span
                          >
                        </b-col>
                        <b-col v-if="p.CommitType" class="bg-light" cols="6"
                        >Giá trị cam kết
                        </b-col>
                        <b-col v-if="p.CommitType" class="bg-light" cols="6"
                        >{{ p.CommitValue }}
                        </b-col>
                        <b-col v-if="p.CommitType" cols="6"
                        >Thời gian cam kết
                        </b-col>
                        <b-col v-if="p.CommitType" cols="6"
                        >{{ p.Months }} tháng
                        </b-col>
                        <b-col class="bg-light" cols="6">Khởi tạo?</b-col>
                        <b-col class="bg-light" cols="6">
                          <feather-icon
                              :icon="
                              p.Active == 2 ? 'CheckSquareIcon' : 'SquareIcon'
                            "
                          />
                          Active?
                        </b-col>
                        <b-col cols="6">DKTT:</b-col>
                        <b-col cols="6"
                        ><span v-if="p.IDNUMBER">Đã đăng ký</span
                        ><span v-else>Chưa đăng ký</span></b-col
                        >
                      </b-row>
                      <b-row>
                        <b-col class="pt-1 text-right" cols="12">
                          <b-button
                              :disabled="isDisabledCreateOrder"
                              size="sm"
                              variant="primary"
                              @click="reActive(p.Msisdn, p.MSIN)"
                          >Khởi tạo
                          </b-button>
                          <b-button
                              class="ml-1"
                              size="sm"
                              variant="primary"
                              @click="OpenModalGhepSim(p)"
                          >Ghép sim
                          </b-button>
                          <!--                          <b-button-->
                          <!--                            variant="primary"-->
                          <!--                            class="ml-1 btn-icon"-->
                          <!--                            @click="rePrint(p.Msisdn, p.MSIN)"-->
                          <!--                            size="sm"-->
                          <!--                            ><feather-icon icon="PrinterIcon"-->
                          <!--                          /></b-button>-->
                          <b-button
                              class="ml-1"
                              size="sm"
                              variant="primary"
                              @click="printOrder(p.Msisdn, p.MSIN, p.MSIN_)"
                          >In tem
                          </b-button>
                          <b-button
                              v-if="p.ESIM == 1"
                              class="mr-1 ml-1 mt-1"
                              size="sm"
                              variant="primary"
                              @click="esimEmail(p.Msisdn)"
                          >Gửi Email eSIM
                          </b-button>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                </table>
              </b-card-text>
            </b-card>
            <div class="d-flex justify-content-around align-items-center">
              <h4>
                Tổng tiền
                <span class="text-primary">{{
                    currentItem.TotalPrice | number
                  }}</span
                ><small
              >({{ (currentItem.ShipmentFee || 0) | number }}đ VC)</small
              >
              </h4>
              <button class="btn btn-primary" @click="handlePayment">Thanh toán</button>
            </div>
          </b-col>
          <b-col cols="9">
            <h4>Thông tin thanh toán</h4>
            <div class="border rounded bg-light p-1">
              <b-row v-if="currentItem.J_VnPay && !isLoading">
                <b-col cols="3">
                  <b-form-group label="Mã GD">
                    <b-form-input
                        v-model="currentItem.J_VnPay.vnp_TransactionNo"
                        disabled
                        size="sm"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Loại thẻ">
                    <b-form-input
                        v-model="currentItem.J_VnPay.vnp_CardType"
                        disabled
                        size="sm"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Ngân hàng">
                    <b-form-input
                        v-model="currentItem.J_VnPay.vnp_BankCode"
                        disabled
                        size="sm"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Ngày/tháng">
                    <b-form-input
                        :value="dateFormat(currentItem.J_VnPay.vnp_PayDate)"
                        disabled
                        size="sm"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group label="Số tiền">
                    <b-form-input
                        :value="
                        $options.filters.number(
                          currentItem.J_VnPay.vnp_Amount / 100
                        )
                      "
                        disabled
                        size="sm"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="9">
                  <b-form-group label="Trạng thái">
                    <b-form-input
                        v-model="currentItem.J_VnPay.vnp_Status"
                        disabled
                        size="sm"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <h4 class="pt-2">Thông tin vận chuyển</h4>
            <div class="border rounded bg-light p-1">
              <span v-if="currentItem.DeliveryType == 2"
              >Đơn nhận tại PGD
                {{
                  currentItem.StoreId &&
                  Stores.find(el => el.value == currentItem.StoreId)
                      ? Stores.find(el => el.value == currentItem.StoreId).text
                      : "Itel"
                }}</span
              >
              <span v-else-if="currentItem.GHTK_Id == null"
              >Chưa có đơn vận chuyển</span
              >
              <span v-else>
                <b-row v-if="!isLoading">
                  <b-col cols="3">
                    <b-form-group label="Mã vận đơn">
                      <b-form-input
                          v-model="currentItem.GHTK_Id"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="9">
                    <b-form-group label="Địa chỉ">
                      <b-form-input
                          v-model="currentItem.Addr"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Tỉnh/Tp">
                      <b-form-input
                          v-model="currentItem.City"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Quận/Huyện">
                      <b-form-input
                          v-model="currentItem.District"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Phường/Xã">
                      <b-form-input
                          v-model="currentItem.Ward"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Tổ/Khu">
                      <b-form-input
                          v-model="currentItem.Hamlet"
                          disabled
                          size="sm"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <h5 class="border-bottom">Trạng thái vận đơn chi tiết</h5>
                <b-row v-if="currentItem.IsFast == 0">
                  <b-col
                      v-for="i in currentItem.J_Shipment_Tracking"
                      :key="i.date_"
                      class="pt-1"
                      cols="12"
                  ><span class="badge badge-light-secondary">{{
                      i.date_
                    }}</span>
                    {{ ghtkStatus.find(m => m.id == i.status).text }}</b-col
                  >
                </b-row>
                <b-row v-else>
                  <b-col
                      v-for="i in currentItem.J_Shipment_Tracking"
                      :key="i.date_"
                      class="pt-1"
                      cols="12"
                  ><span class="badge badge-light-secondary">{{
                      i.date_
                    }}</span>
                    {{ ahmStatus.find(m => m.id == i.status).text }}</b-col
                  >
                </b-row>
              </span>
            </div>
            <h4 class="pt-2">Lịch sử đăng ký TTTB</h4>
            <div class="">
              <table class="table table-sm table-bordered table-striped">
                <tr>
                  <th>Số iTel</th>
                  <th>Họ & Tên</th>
                  <th>Giới tính</th>
                  <th>ID Card</th>
                  <th>ID Issued Date</th>
                  <th>ID Issued Place</th>
                  <th>Birthday</th>
                  <th>Resisdent Address</th>
                  <th>Notes</th>
                </tr>
                <tr v-for="i in currentItem.dktts" :key="i.CUSTOMER_HIS_ID">
                  <td class="text-primary">{{ i.ISDN }}</td>
                  <td>{{ i.FULL_NAME }}</td>
                  <td>
                    <span v-if="i.GENDER == 1">Nam</span><span v-else>Nữ</span>
                  </td>
                  <td>{{ i.ID_CARD }}</td>
                  <td>{{ i.ID_ISSUED_DATE_ }}</td>
                  <td>{{ i.ID_ISSUED_PLACE }}</td>
                  <td>{{ i.BIRTHDAY_ }}</td>
                  <td>{{ i.RESIDENT_ADDRESS }}</td>
                  <td>{{ i.REQUEST_DESC }}</td>
                </tr>
              </table>
            </div>
            <h4 class="pt-2">Ghi chú</h4>
            <div class="border rounded bg-light p-1">
              {{ currentItem.Notes }}
            </div>
            <b-row class="pt-1 font-small">
              <b-col cols="12">
                <h5>Tin nhắn/Email</h5>
                <b-card body-class="p-0" class="p-0 mb-1">
                  <b-card-text>
                    <table class="table table-bordered table-sm">
                      <tr>
                        <th>Loại</th>
                        <th>Tin nhắn</th>
                        <th>Ngày</th>
                      </tr>
                      <tr v-for="i in this.currentItem.notify" :key="i.Id">
                        <td>{{ i.NotifyType }}</td>
                        <td>{{ i.Result }}</td>
                        <td>{{ i.date_ }}</td>
                      </tr>
                    </table>
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col cols="12">
                <h5>Logs</h5>
                <b-card v-if="currentItem.logs" body-class="p-0" class="p-0">
                  <b-card-text style="overflow: auto">
                    <table class="table table-bordered table-sm">
                      <tr>
                        <th>Loại</th>
                        <th style="max-width: 50vw">Logs</th>
                        <th>Ghi chú</th>
                        <th>Ngày</th>
                      </tr>
                      <tr v-for="i in currentItem.logs" :key="i.Id">
                        <td>{{ i.LogType }}</td>
                        <td style="max-width: 50vw">{{ i.Content }}</td>
                        <td>{{ i.SubRefId }}</td>
                        <td>{{ i.date_ }}</td>
                      </tr>
                    </table>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-dktt"
        :title="'Thông tin lịch sử đăng ký TTTB'"
        ok-only
        size="xl"
    >
    </b-modal>
    <b-modal
        id="modal-ghep-sim"
        :title="'Ghép sim'"
        ok-only
        size="md"
        @ok="handleOkGhepSim"
    >
      <b-form-input v-model="bindSimNumber" type="number"></b-form-input>
      <p v-if="bindSimNumber.length !== 20" class="text-primary">
        Vui lòng nhập 20 số
      </p>
    </b-modal>
    <b-modal
        id="modal-thanh-toan"
        :title="'Thanh toán'"
        hide-footer
        size="md"
    >
      <div class="d-flex justify-content-center">
        <img :src="paymentResponse.qrUrl" alt="">
      </div>

      <div class="d-flex justify-content-around mt-4">
<!--        <button class="btn btn-primary" >Sao chép ảnh</button>-->
        <button class="btn btn-outline-primary" @click="$bvModal.hide('modal-thanh-toan')">Đóng</button>
      </div>
    </b-modal>
    <b-modal
        id="modal-cap-nhat-trang-thai-don"
        :title="'Cập nhật trạng thái đơn'"
        size="md"
        hide-footer
    >
     <div>
       <input type="file" class="form-control" @change="handleAddChangeOrderStatusFile">
       <div class="mt-4 d-flex justify-content-around">
         <button class="btn btn-outline-primary" @click="downloadTemplateChangeOrderStatusFile">Tải file mẫu</button>
         <button class="btn btn-primary" @click="handleUploadChangeOrderStatusFile">Gửi file</button>
       </div>
     </div>
    </b-modal>
    <PopupCreateOrder
        :modalSrc="$ctx.URL_FRONTEND + '/dien-thoai-thiet-bi?iframe=true'"
        modalId="popupCreateOrder"
        @onCreateOrderSuccess="loadItems()"
    />
    <PopupCreateOrder
        :modalSrc="$ctx.URL_FRONTEND + '/mua-sim'"
        modalId="popupCreateSimOrder"
        @onCreateOrderSuccess="loadItems()"
    />
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import SearchSelect from "../components/select/SearchSelect.vue";
import PopupCreateOrder from "./PopupCreateOrder.vue";
import {$ctx} from "@themeConfig";
import {saveAs} from "file-saver-es";
export default {
  computed: {
    $ctx() {
      return $ctx;
    }
  },
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BCardText,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    SearchSelect,
    PopupCreateOrder
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple
  },
  mounted() {
    // Listen to message from child window
    window.addEventListener("message", this.handleMessageEventer, false);
    this.loadMasterData();
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessageEventer);
  },
  watch: {
    $route(to, from) {
      this.loadMasterData();
    }
  },
  methods: {
    async handlePayment(){
      this.loading(true)
      await useJwt.postEx(
          $ctx.URL_FRONTEND.includes("dev")
              ? "https://itel.dev/api/web/order/pay-order"
              : "https://itel.vn/api/web/order/pay-order",
          {
            paymentChannel: "MBQR",
            orderIds: [
              this.currentItem.Id
            ],
            paymentOptions: {
              merchant: "DGT"
            }
          }
      ).then(res=>{
        this.loading(false)
        this.$bvModal.show("modal-thanh-toan");
        this.paymentResponse = res.data.result
      }).catch(err=>{
        this.loading(false)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: err.response.data.message? err.response.data.message:"Thanh toán thất bại",
            icon: "AlertTriangleIcon",
            variant: "error"
          }
        });
      })
    },
    async getListOrderStatus(){
      await useJwt.get("order-status").then(res=>{
        res.data.result.forEach(item=>{
          this.listOrderStatus.push({
            value:item.id,
            text:item.name,
            id:item.id
          })
        })
        const statusField = this.fields.find(f => f.field === 'Status');
        if (statusField) {
          statusField.filterOptions.filterDropdownItems = this.listOrderStatus;
        }
      })
    },
    handleOpenModalChangeOrderStatus(){
      this.$bvModal.show("modal-cap-nhat-trang-thai-don");
    },
    async downloadTemplateChangeOrderStatusFile(){
      this.loading(true)
      await useJwt.get("b2c/updateStatusTemplate").then(res=>{
        this.loading(false)
        // console.log(res.data.result)
        saveAs("data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"+res.data.result,"Mẫu cập nhật trạng thái đơn.xlsx")
      }).catch(err=>{
        // console.log(err)
        this.loading(false)
        this.$toast.warning("Có lỗi xảy ra vui lòng thử lại", {
          icon: true,
          closeButton: "button"
        });
      })
    },
    handleAddChangeOrderStatusFile(e){
      if (!e.target.files || !e.target.files[0]) return;
      const file=e.target.files[0]
      const reader = new FileReader();
      reader.onload = async (e) => {
        const bstr = e.target.result;
        this.changeOrderStatusFile=bstr
      };
      reader.readAsDataURL(file);
    },
    async handleUploadChangeOrderStatusFile(){
      this.loading(true)
      await useJwt.post('b2c/updateOrderStatusByFile',{
        file:this.changeOrderStatusFile.replace("data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,","")
      }).then(res=>{
        this.loading(false)
        if(res.data.code===200){
          this.$toast.success(res.data.message, {
            icon: true,
            closeButton: "button"
          });
          this.$bvModal.hide("modal-cap-nhat-trang-thai-don")
        }
      }).catch(err=>{
        this.loading(false)
        this.$toast.error(err.response.data.message, {
          icon: true,
          closeButton: "button"
        });
        saveAs("data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"+err.response.data.result,"Cập nhật trạng thái đơn lỗi.xlsx")
      })
    },
    addNote() {
      if (this.currentItem.note.length <= 0) {
        this.$toast.warning("Vui lòng nhập ghi chú!", {
          icon: true,
          closeButton: "button"
        });
        return;
      }
      useJwt
          .post("orderNotes/" + this.currentItem.Id, {
            notes: this.currentItem.note
          })
          .then(res => {
            this.$toast.success("Thêm ghi chú thành công!", {
              icon: true,
              closeButton: "button"
            });
          })
          .catch(err => {
            this.$toast.warning("Thêm ghi chú thất bại!", {
              icon: true,
              closeButton: "button"
            });
          });
    },
    importNumber() {
      console.log(this.$refs.importNumberInput.files[0]);
      const reader = new FileReader();
      reader.onload = reader => {
        useJwt
            .post("ecommerce/import-contact-phone", {
              file: reader.target.result.replace(
                  "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
                  ""
              )
            })
            .then(result => {
              if (result.data.result) {
                const mediaType =
                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
                var a = document.createElement("a");
                a.href = mediaType + result.data.result;
                a.download = "file.xlsx";
                a.textContent = "Download file!";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                this.$toast.success("Tải lên thành công!", {
                  icon: true,
                  closeButton: "button"
                });
              }
            })
            .catch(err => {
              const mediaType =
                  "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
              var a = document.createElement("a");
              a.href = mediaType + err.response.data.result;
              a.download = "file.xlsx";
              a.textContent = "Download file!";
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              this.$toast.warning(
                  err.response?.data?.message || "Tải lên thất bại!",
                  {
                    icon: true,
                    closeButton: "button"
                  }
              );
            });
      };
      reader.readAsDataURL(this.$refs.importNumberInput.files[0]);
    },
    handleOkGhepSim(bvModalEvt) {
      if (this.bindSimNumber.length != 20) {
        bvModalEvt.preventDefault();
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng nhập 20 số",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
      } else {
        this.currentPhone.serial = this.bindSimNumber;
        useJwt
            .post("order/create_sub", this.currentPhone)
            .then(res => {
              if (res.data.code === 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Thành công",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: res.data.result,
                    icon: "AlertTriangleIcon",
                    variant: "danger"
                  }
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
      }
    },
    OpenModalGhepSim(currentPhone) {
      this.bindSimNumber = "";
      this.$bvModal.show("modal-ghep-sim");
      this.currentPhone = {
        orderId: this.currentItem.Id,
        msisdn: currentPhone.Msisdn,
        detailId: currentPhone.DetailId
      };
    },
    handleMessageEventer(e) {
      let key = e.message ? "message" : "data";
      let data = e[key];

      if (typeof data == "object") {
        if (data?.type == "onReload") {
          this.loadItems();
        }

        if (data?.type == "onOrderSIM" || data?.type == "onOrderDEVICE") {
          this.loading(true);
          let payload = data.data;
          if (
              payload.cart.find(el => el.product_type && el.product_type != 100)
          ) {
            payload.transactionType = "DEVICE";
          }
          useJwt
              .post("create-order", payload)
              .then(response => {
                this.loading(false);
                this.loadItems();
                if (data?.type == "onOrderSIM") {
                  document
                      .getElementById("iframepopupCreateSimOrder")
                      .contentWindow.postMessage(
                      {
                        type: "onOrderSIMSucess",
                        data: {id: response.data.result}
                      },
                      "*"
                  );
                }
                if (data?.type == "onOrderDEVICE") {
                  document
                      .getElementById("iframepopupCreateOrder")
                      .contentWindow.postMessage(
                      {
                        type: "onOrderSucess",
                        data: {id: response.data.result}
                      },
                      "*"
                  );
                }
              })
              .catch(error => {
                if (data?.type == "onOrderSIM") {
                  document
                      .getElementById("iframepopupCreateSimOrder")
                      .contentWindow.postMessage(
                      {type: "onOrderSIMFail", data: {}},
                      "*"
                  );
                }
                if (data?.type == "onOrderDEVICE") {
                  document
                      .getElementById("iframepopupCreateOrder")
                      .contentWindow.postMessage(
                      {type: "onOrderFail", data: {}},
                      "*"
                  );
                }
                this.loading(false);
              });
        }
      }
    },
    /*viewDKTTHist(p){
      console.log(p);
      this.dkttRows = p.reg_hist;
      this.$bvModal.show('modal-dktt');
    },*/
    createShipment1() {
      if (confirm("Chỉ tạo vận đơn mới khi vận đơn cũ không tạo lại được!")) {
        this.loading(true);
        useJwt
            .get("ghtk/create-order-force/" + this.currentItem.Id)
            .then(response => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.result.message,
                  icon: "AlertTriangleIcon",
                  variant: "info"
                }
              });
              console.log(response.data.result);
              this.loading(false);
            })
            .catch(error => {
              if (error.response.data.code == 403) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Không có quyền thao tác nghiệp vụ này!",
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.response.data.result,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
    },
    createShipment() {
      this.loading(true);
      useJwt
          .get("ghtk/create-order/" + this.currentItem.Id)
          .then(response => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Tạo đơn vận thành công",
                icon: "AlertTriangleIcon",
                variant: "info"
              }
            });
            console.log(response.data.result);
            this.loading(false);
          })
          .catch(error => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.response.data.result.message,
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
            this.loading(false);
          });
    },
    createShipmentGHN() {
      if (confirm("Chỉ tạo vận đơn mới khi vận đơn cũ đã hủy")) {
        this.loading(true);
        useJwt
            .get(
                "ship/create-order/" +
                this.currentItem.ShippingPartner +
                "/" +
                this.currentItem.Id
            )
            .then(response => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Tạo đơn vận thành công",
                  icon: "AlertTriangleIcon",
                  variant: "info"
                }
              });
              console.log(response.data.result);
              this.loading(false);
            })
            .catch(error => {
              if (error.response.data.code == 403) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Không có quyền thao tác nghiệp vụ này!",
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.response.data.result,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
    },
    updatePhoneAndMail() {
      if (!this.isEditPhoneEmail) {
        this.isEditPhoneEmail = true;
        return;
      }

      this.loading(true);
      const data = {
        ContactPhone: this.currentItem.ContactPhone,
        Email: this.currentItem.Email,
        OrderId: this.currentItem.Id,
        Addr: this.currentItem.Addr,
        CityId: this.currentItem.CityId,
        DistrictId: this.currentItem.DistrictId,
        WardId: this.currentItem.WardId,
        HamletId: this.currentItem.HamletId
      };
      useJwt
          .put("update-order-info/" + this.currentItem.Id, data)
          .then(response => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "info"
              }
            });
            this.isEditPhoneEmail = false;
            this.loading(false);
          })
          .catch(error => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
            this.isEditPhoneEmail = false;
            this.loading(false);
          });
    },
    reActive(msisdn, msin) {
      this.loading(true);
      useJwt
          .post("sps/createSub2", {
            orderId: this.currentItem.Id,
            msisdn: msisdn,
            msin: msin
          })
          .then(response => {
            console.log(response.data.result);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.result.createSub,
                icon: "AlertTriangleIcon",
                variant: "info"
              }
            });
            this.loading(false);
          })
          .catch(error => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
            this.loading(false);
          });
    },
    printOrder(msisdn, msin, iccid) {
      this.loading(true);
      useJwt
          .post("print/print-order2", {
            orderId: this.currentItem.Id,
            msisdn: msisdn,
            msin: msin,
            iccid: iccid
          })
          .then(response => {
            console.log(response.data.result);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.result,
                icon: "AlertTriangleIcon",
                variant: "info"
              }
            });
            this.loading(false);
          })
          .catch(error => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
            this.loading(false);
          });
    },
    printEcomLabel(orderId) {
      this.loading(true);
      useJwt
          .post("print/print-ecom", {
            orderId: this.currentItem.Id
          })
          .then(response => {
            console.log(response.data.result);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.result,
                icon: "AlertTriangleIcon",
                variant: "info"
              }
            });
            this.loading(false);
          })
          .catch(error => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
            this.loading(false);
          });
    },
    rePrint(msisdn, msin) {
      this.loading(true);
      useJwt
          .post("sps/printSub", {
            orderId: this.currentItem.Id,
            msisdn: msisdn,
            msin: msin
          })
          .then(response => {
            console.log(response.data.result);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.result.createSub,
                icon: "AlertTriangleIcon",
                variant: "info"
              }
            });
            this.loading(false);
          })
          .catch(error => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
            this.loading(false);
          });
    },
    esimEmail(msisdn) {
      this.loading(true);
      useJwt
          .get("send-mail-esim/" + this.currentItem.Id + "/" + msisdn)
          .then(response => {
            console.log(response.data.result);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Kết quả: " + response.data.result,
                icon: "AlertTriangleIcon",
                variant: "info"
              }
            });
            this.loading(false);
          })
          .catch(error => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
            this.loading(false);
          });
    },
    dateFormat(v) {
      return moment(v, "YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm:ss");
    },
    changeTab(i) {
      this.serverParams.columnFilters.searchString = null;
      this.serverParams.columnFilters.Status = i;
      this.loadItems();
    },
    quickSearch() {
      this.serverParams.columnFilters.Status = null;
      this.serverParams.columnFilters.searchString = this.searchString;
      this.loadItems();
    },
    loadMasterData() {
      this.fetchCities();
      this.fetchStores();
      this.getListOrderStatus()
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      if (!newProps.page){
        this.serverParams.page = 1;
      }
      if (this.serverParams.columnFilters.CreateDate_) {
        this.serverParams.columnFilters.FromDate = this.serverParams.columnFilters.CreateDate_;
        this.serverParams.columnFilters.ToDate = this.serverParams.columnFilters.CreateDate_;
      } else {
        if (this.serverParams.columnFilters.FromDate) {
          delete this.serverParams.columnFilters["FromDate"];
        }
        if (this.serverParams.columnFilters.ToDate) {
          delete this.serverParams.columnFilters["ToDate"];
        }
      }
    },
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      if (this.isLoading) {
        return;
      }
      this.updateParams(params);
      this.loadItems();
    },
    loadItems() {
      this.loading(true);
      this.isLoading = true;
      let data = {
        ...this.serverParams,
        columnFilters: {
          ...(this.serverParams.columnFilters
              ? this.serverParams.columnFilters
              : [])
        }
      };
      if (data.columnFilters.CreateDate_ != undefined) {
        delete data.columnFilters["CreateDate_"];
      }
      this.isFirstTimeLoad = false;
      useJwt
          .post("ghtk/order-list", data)
          .then(response => {
            this.rows = response.data.result;
            //console.log(this.rows)
            this.totalRecords = response.data.totalRecords;
            this.rows.forEach(i => {
              if (i.J_Shipment) {
                i.J_Shipment = JSON.parse(i.J_Shipment);
              }
            });
            this.isLoading = false;
            this.loading(false);
          })
          .catch(error => {
            this.loading(false);
            this.isLoading = false;
          });
    },
    viewChangetstaus(idx) {
      this.currentItem.newStatus = this.currentItem.Status;
      this.isLoading = true;
      this.currentItem = this.rows[idx];
      this.$bvModal.show("modal-change-status");
      this.isLoading = false;
    },
    ahmOrderCancel() {
      if (confirm("Bạn thực sự muốn xoá vận đơn Ahamove?")) {
        this.loading(true);
        useJwt
            .get("cancel/" + this.currentItem.GHTK_Id + "/Xoá vận đơn từ CRM")
            .then(response => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message,
                  icon: "AlertTriangleIcon",
                  variant: "info"
                }
              });
              console.log(response.data.result);
              this.loading(false);
            })
            .catch(error => {
              if (error.response.data.code == 403) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Không có quyền thao tác nghiệp vụ này!",
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.response.data.result,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
    },
    handleChangeStatus(bvModalEvt) {
      bvModalEvt.preventDefault();
      useJwt
          .put(
              "order/" + this.currentItem.Id + "/" + this.currentItem.newStatus,
              {notes: this.currentItem.notes}
          )
          .then(response => {
            this.loadItems();
            this.loading(false);
            this.$bvModal.hide("modal-change-status");
          })
          .catch(error => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
            this.loading(false);
          });
    },
    view(idx) {
      this.isLoading = true;
      this.currentItem = this.rows[idx];
      try {
        if (this.currentItem.J_VnPay != null) {
          this.currentItem.J_VnPay = JSON.parse(this.currentItem.J_VnPay);
        }
        if (this.currentItem.J_Shipment_Tracking != null) {
          this.currentItem.J_Shipment_Tracking = JSON.parse(
              this.currentItem.J_Shipment_Tracking
          );
        }
      } catch (e) {
      }
      if (
          this.currentItem.J_VnPay &&
          this.currentItem.J_VnPay.vnp_ResponseCode
      ) {
        var x = this.vnPayErrors.find(
            m => m.id == this.currentItem.J_VnPay.vnp_ResponseCode
        );
        if (x != undefined) {
          this.currentItem.J_VnPay.vnp_Status = x.text;
        } else {
          this.currentItem.J_VnPay.vnp_Status =
              "Trạng thái không xác định - " +
              this.currentItem.J_VnPay.vnp_ResponseCode;
        }
      }
      this.loading(true);
      if (this.currentItem.CityId) {
        this.fetchDistricts(false, false);
        this.fetchWards(false, false);
        this.fetchHamlet(false, false);
      }
      useJwt
          .get("order-detail/" + this.currentItem.Id)
          .then(response => {
            this.currentItem.ListPhones = response.data.result.phones;
            this.currentItem.steps = response.data.result.steps.filter(
                m => m.LogType == "Order-Status"
            );
            this.currentItem.logs = response.data.result.steps;
            this.currentItem.notify = response.data.result.notify;
            this.currentItem.dktts = response.data.result.dktts;
            this.currentItem.note = "";

            this.listOrderStatus.forEach(m => (m.has = false));
            this.currentItem.steps.forEach(i => {
              var s = this.listOrderStatus.find(m => m.id == i.Content);
              if (s != undefined) {
                s.has = true;
              }
            });
            var s1 = this.listOrderStatus.find(m => m.id == this.currentItem.Status);
            console.log("s1 --->", s1);
            if (s1.id === 91) {
              this.isDisabledCreateOrder = true;
            }
            if (s1 != undefined) {
              s1.has = true;
            }
            //console.log(this.currentItem);
            //console.log(this.statusList.find(m=>m.id==this.currentItem.Status));
            this.currentItem = JSON.parse(JSON.stringify(this.currentItem));
            this.loading(false);
            this.$bvModal.show("modal-view");
            this.isLoading = false;
          })
          .catch(error => {
            this.loading(false);
            this.isLoading = false;
          });
      useJwt
          .get("ship/get-partner/" + this.currentItem.Id)
          .then(response => {
            this.Partner = response.data.result.map(item => {
              return {
                value: item.id,
                text: item.value,
                selected: item.selected
              };
            });
            this.currentItem.ShippingPartner = this.Partner.find(
                m => m.selected === 1
            ).value;
            this.currentItem.changeShippingPartner = this.Partner.length > 1;
            this.loading(false);
            this.$bvModal.show("modal-view");
            this.isLoading = false;
          })
          .catch(error => {
            this.loading(false);
            this.isLoading = false;
          });
    },
    async handleOk(bvModalEvt) {
    },
    handleHide() {
      // this.loadItems();
      this.isEditPhoneEmail = false;
      this.isDisabledCreateOrder = false;
    },
    async fetchCities() {
      try {
        const res = await useJwt.post("getMasterData/GHTK_City", {
          columnFilters: {},
          sort: [],
          page: 1,
          pageSize: 1000
        });

        this.Cities = res.data.result.map(item => {
          return {
            value: item.Id,
            text: item.Name
          };
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi trong quá trình lấy dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
      }
    },
    async fetchDistricts(isCityChange = false, showLoading = true) {
      if (isCityChange) {
        this.currentItem.DistrictId = 0;
        this.currentItem.WardId = 0;
      }

      if (this.currentItem.CityId > 0) {
        if (showLoading) {
          this.loading(true);
        }
        useJwt
            .post("getMasterData/GHTK_District", {
              columnFilters: {CityId: this.currentItem.CityId},
              sort: [],
              page: 1,
              pageSize: 1000
            })
            .then(response => {
              this.Districts = response.data.result.map(item => {
                return {
                  value: item.Id,
                  text: item.Name
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchWards(isDistrictChange = false, showLoading = true) {
      if (isDistrictChange) {
        this.currentItem.WardId = 0;
      }

      if (this.currentItem.DistrictId > 0) {
        if (showLoading) {
          this.loading(true);
        }

        useJwt
            .post("getMasterData/GHTK_Ward", {
              columnFilters: {DistrictId: this.currentItem.DistrictId},
              sort: [],
              page: 1,
              pageSize: 1000,
              lang: this.$l
            })
            .then(response => {
              this.Wards = response.data.result.map(item => {
                return {
                  value: item.Id,
                  text: item.Name
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchHamlet(isDistrictChange = false, showLoading = true) {
      this.hamlets = [];
      if (isDistrictChange) {
        this.hamlets.push({value: 0, text: "Khác"});
        this.currentItem.HamletId = 0;
      }

      if (this.currentItem.WardId >= 0) {
        if (showLoading) {
          this.loading(true);
        }

        useJwt
            .post("getMasterData/GHTK_Hamlet", {
              columnFilters: {WardId: this.currentItem.WardId},
              sort: [],
              page: 1,
              pageSize: 1000,
              lang: this.$l
            })
            .then(response => {
              for (let i in response.data.result) {
                this.hamlets.push({
                  value: response.data.result[i].Id,
                  text: response.data.result[i].Name
                });
              }
              this.hamlets.push({value: 0, text: "Khác"});
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchStores() {
      useJwt
          .post("getMasterData/B2C_Store", {
            columnFilters: {},
            sort: [],
            page: 1,
            pageSize: 1000
          })
          .then(response => {
            this.Stores = response.data.result.map(item => {
              return {
                value: item.Id,
                text: item.Name
              };
            });
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Có lỗi trong quá trình lấy dữ liệu!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    }
  },
  data() {
    return {
      isFirstTimeLoad: true,
      isEditPhoneEmail: false,
      searchString: "",
      isLoading: false,
      totalRecords: 0,
      rows: [],
      //dkttRows:[],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchTerm: "",
      currentItem: {},
      Cities: [],
      Districts: [],
      Partner: [],
      Wards: [],
      Stores: [],
      hamlets: [],
      isDisabledCreateOrder: false,
      fields: [
        {
          field: "Id",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Mã đơn hàng",
          width: "110px"
        },
        {
          field: "CreateDate_",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Ngày tạo",
          width: "130px"
        },
        {
          field: "FullName",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Họ tên KH"
        },
        {
          field: "Phones",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Số mua",
          width: "100px"
        },
        {
          field: "TotalPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Giá",
          tdClass: "text-right",
          width: "90px"
        },
        {
          field: "DeliveryType",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Giao tận nơi?",
          tdClass: "text-center",
          width: "60px"
        },
        {
          field: "PaymentChannel",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "HTTT",
          tdClass: "text-center",
          width: "90px"
        },
        {
          field: "PaymentCode",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Mã thanh toán",
          tdClass: "text-center",
          width: "90px"
        },
        // {
        //   field: "ECommercePlatform",
        //   filterOptions: { enabled: true, placeholder: "" },
        //   label: "TMĐT",
        //   tdClass: "text-center",
        //   width: "90px",
        // },
        // {
        //   field: "IsFast",
        //   filterOptions: { enabled: true, placeholder: "" },
        //   label: "Hoả tốc?",
        //   tdClass: "text-center",
        //   width: "70px",
        // },
        {
          field: "PromotionCode",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Mã giảm giá?",
          tdClass: "text-center",
          width: "70px"
        },
        {
          field: "Status",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: this.listOrderStatus
          },
          label: "Tình trạng?",
          width: "140px"
        },
        {
          field: "GHTK_Id",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Vận chuyển"
        },
        {
          field: "CreateFrom",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Nguồn đơn"
        },
        {
          field: "CreateBy",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Người tạo"
        },
        {
          field: "ECommerceNotes",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Ghi chú",
          tdClass: "text-center",
          width: "90px"
        },
        {field: "action", label: "Thao tác", width: "80px", trigger: "enter"}
      ],
      statusList: [
        {id: 0, text: "Chưa thanh toán"},
        {id: 1, text: "Đã thanh toán/COD"},
        {id: 2, text: "Đã xác nhận/Chuyển vận đơn"},
        {id: 3, text: "Hoàn thành giao hàng"},
        {id: 11, text: "Chờ Callboot xác nhận đơn COD"},
        {id: 90, text: "Lỗi thanh toán"},
        {id: 91, text: "Trả hàng"},
        {id: 92, text: "Hủy đơn"},
        {id: 93, text: "Đơn hủy từ Baseus"},
        {id: 300, text: "Khác"}
      ],
      vnPayErrors: [
        {id: "00", text: "Giao dịch thành công"},
        {
          id: "07",
          text:
              "Trừ tiền thành công. Giao dịch bị nghi ngờ (liên quan tới lừa đảo, giao dịch bất thường)."
        },
        {
          id: "09",
          text:
              "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng chưa đăng ký dịch vụ InternetBanking tại ngân hàng."
        },
        {
          id: "10",
          text:
              "Giao dịch không thành công do: Khách hàng xác thực thông tin thẻ/tài khoản không đúng quá 3 lần"
        },
        {
          id: "11",
          text:
              "Giao dịch không thành công do: Đã hết hạn chờ thanh toán. Xin quý khách vui lòng thực hiện lại giao dịch."
        },
        {
          id: "12",
          text:
              "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng bị khóa."
        },
        {
          id: "13",
          text:
              "Giao dịch không thành công do Quý khách nhập sai mật khẩu xác thực giao dịch (OTP). Xin quý khách vui lòng thực hiện lại giao dịch."
        },
        {
          id: "24",
          text: "Giao dịch không thành công do: Khách hàng hủy giao dịch"
        },
        {
          id: "51",
          text:
              "Giao dịch không thành công do: Tài khoản của quý khách không đủ số dư để thực hiện giao dịch."
        },
        {
          id: "65",
          text:
              "Giao dịch không thành công do: Tài khoản của Quý khách đã vượt quá hạn mức giao dịch trong ngày."
        },
        {id: "75", text: "Ngân hàng thanh toán đang bảo trì."},
        {
          id: "79",
          text:
              "Giao dịch không thành công do: KH nhập sai mật khẩu thanh toán quá số lần quy định. Xin quý khách vui lòng thực hiện lại giao dịch"
        },
        {
          id: "99",
          text: "Lỗi thanh toán ngân hàng, quý khách vui lòng thử lại"
        }
      ],
      ahmStatus: [
        {id: "IDLE", text: "Đã tiếp nhận"},
        {id: "ASSIGNING", text: "Đã điều phối lấy hàng"},
        {id: "ACCEPTED", text: "Đã tiếp nhận"},
        {id: "IN PROCESS", text: "Shipper báo đã lấy hàng"},
        {id: "COMPLETED", text: "Hoàn thành đơn hàng"},
        {id: "CANCELLED", text: "Hủy đơn hàng"}
      ],
      ghtkStatus: [
        {id: "-1", text: "Hủy đơn hàng"},
        {id: "1", text: "Chưa tiếp nhận"},
        {id: "2", text: "Đã tiếp nhận"},
        {id: "3", text: "Đã lấy hàng/Đã nhập kho"},
        {id: "4", text: "Đã điều phối giao hàng/Đang giao hàng"},
        {id: "5", text: "Đã giao hàng/Chưa đối soát"},
        {id: "6", text: "Đã đối soát"},
        {id: "7", text: "Không lấy được hàng"},
        {id: "8", text: "Hoãn lấy hàng"},
        {id: "9", text: "Không giao được hàng"},
        {id: "10", text: "Delay giao hàng"},
        {id: "11", text: "Đã đối soát công nợ trả hàng"},
        {id: "12", text: "Đã điều phối lấy hàng/Đang lấy hàng"},
        {id: "13", text: "Đơn hàng bồi hoàn"},
        {id: "20", text: "Đang trả hàng (COD cầm hàng đi trả)"},
        {id: "21", text: "Đã trả hàng (COD đã trả xong hàng)"},
        {id: "123", text: "Shipper báo đã lấy hàng"},
        {
          id: "127",
          text: "Shipper (nhân viên lấy/giao hàng) báo không lấy được hàng"
        },
        {id: "128", text: "Shipper báo delay lấy hàng"},
        {id: "45", text: "Shipper báo đã giao hàng"},
        {id: "49", text: "Shipper báo không giao được giao hàng"},
        {id: "410", text: "Shipper báo delay giao hàng"}
      ],
      serverParams: {
        columnFilters: {},
        sort: [{field: "CreateDate", type: "desc"}],
        page: 1,
        pageSize: 50,
        lang: 1
      },
      required,
      bindSimNumber: "",
      currentPhone: {},
      importPhoneFile: null,
      changeOrderStatusFile:"",
      listOrderStatus:[],
      paymentResponse: {}
    };
  }
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style>
.vgt-responsive {
  height: 500px;
}

.vgt-table {
  border-collapse: separate !important;
  border-spacing: 0;
}

.vgt-table thead {
  position: sticky;
  top: 0px;
  background-color: white;
  z-index: 10;
}

.style-input {
  height: 100%;
}

.style-datepicker {
  width: 200px !important;
}

.b2c-order .vgt-wrap {
  /* max-height: calc(100vh - 300px); */
  overflow: auto;
}

.font-small .table-sm {
  font-size: 11px;
}

.col-gap-1 {
  column-gap: 1rem;
}
</style>
